<template>
  <div class="col-md-3">
    <div class="modern-card shadow-sm p-3">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <small class="text-uppercase text-muted font-weight-bold">{{ title }}</small>
        </div>
        <div class="icon-wrapper">
          <i :class="icon"></i>
        </div>
      </div>

      <div class="mt-2">
        <h4 class="font-weight-bold mb-0 text-dark fs-5">
          {{ value }}
        </h4>
        <!-- <small :class="subtitleClass">
          <i :class="subtitleIcon"></i> {{ subtitle }}
        </small> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModernCard",
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: "fas fa-briefcase"
    },
    subtitle: {
      type: String,
      default: ""
    },
    subtitleIcon: {
      type: String,
      default: "fas fa-arrow-up"
    },
    subtitleClass: {
      type: String,
      default: "text-success font-weight-medium"
    }
  }
};
</script>

<style scoped>
.modern-card {
  background: #f8fafc;
  border: none;
  border-radius: 16px;
  padding: 20px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.modern-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.icon-wrapper {
  background: linear-gradient(135deg, #fff0e6, #ffe4b3);
  color: #b45309;
  border-radius: 12px;
  padding: 8px;
  font-size: 18px;
}

.modern-card small {
  font-size: 0.75rem;
  letter-spacing: 0.4px;
}

.modern-card h4 {
  font-size: 1.6rem;
}

.text-success i {
  font-size: 0.8rem;
  margin-right: 4px;
}
</style>
